export default __webpack_public_path__ + "static/header-products-and-services-579fe9a4bd6dd5cd458bff97894e9378.webp";